// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"59fd65db","57":"2382fc95","124":"a7f894af","353":"d6da2b30","449":"e97b29b0","453":"703d9625","660":"26a53d6c","697":"35f57cc4","712":"77c983b4","819":"59874396"}[chunkId] + ".chunk.js";
};